enum HorizontalAlignmentEnum {
  Left = 'LEFT',
  Right = 'RIGHT',
  Center = 'CENTER',
}

export default HorizontalAlignmentEnum;
